export const getSelectedFilters = (facets) =>
  Object.values(facets)
    .flat()
    .filter((item) => item?.selected && item?.value !== 'all').length;

const CATEGORY_ROUTE = 'serp_category';
const BASE_ROUTE_PARAM_KEYS = new Set(['header', 'categorySlug']);
const FACET_PATH_PARAM_KEYS = new Set(['facet', 'filter']);
const PAGINATION_PARAM_KEYS = new Set(['pagination', 'page']);
const SEO_LINK_FACET_KEYS = new Set([
  'feature_tags_facet',
  'integrated_with_facet',
]);

const hasQueryValue = (value) => {
  if (Array.isArray(value)) {
    return value.some(hasQueryValue);
  }

  return value !== undefined && value !== null && value !== '';
};

const hasActiveParam = (query, keys) => {
  const queryParams = query || {};
  return Array.from(keys).some((key) => hasQueryValue(queryParams[key]));
};

const hasActiveFilterQueryParam = (query) =>
  Object.entries(query || {}).some(([key, value]) => {
    if (
      BASE_ROUTE_PARAM_KEYS.has(key) ||
      FACET_PATH_PARAM_KEYS.has(key) ||
      PAGINATION_PARAM_KEYS.has(key)
    ) {
      return false;
    }

    return hasQueryValue(value);
  });

export const shouldRenderSeoFacetHref = ({
  isSeo,
  route,
  query,
  categoryHasSeoFacets,
}) =>
  Boolean(
    isSeo &&
      route === CATEGORY_ROUTE &&
      categoryHasSeoFacets &&
      !hasActiveParam(query, FACET_PATH_PARAM_KEYS) &&
      !hasActiveParam(query, PAGINATION_PARAM_KEYS) &&
      !hasActiveFilterQueryParam(query)
  );

export const shouldRenderAllSeoFacetsForBot = ({
  facetKey,
  isBot,
  route,
  query,
  categoryHasSeoFacets,
}) =>
  Boolean(
    isBot &&
      SEO_LINK_FACET_KEYS.has(facetKey) &&
      shouldRenderSeoFacetHref({
        isSeo: true,
        route,
        query,
        categoryHasSeoFacets,
      })
  );

export const FACETS_EVENT_NAMES = {
  category_leaders_facet: 'category-leaders',
  company_industry_facet: 'industry',
  company_size_facet: 'company-size',
  feature_tags_facet: 'features',
  integrated_with_facet: 'integrations',
  oses_facet: 'devices',
  pricingcategories_facet: 'pricing',
  rating_facet: 'overall-rating',
  rating_stars_ge: 'overall-rating',
  time_used_facet: 'time-used',
  typecustomers_facet: 'organization-types',
  community_company_industry: 'industry',
  community_company_size: 'company-size',
};

export const TITLES = {
  community_company_industry: 'Industry',
  community_company_size: 'Company size',
  company_industry_facet: 'Industry',
  company_size_facet: 'Company size',
  feature_tags_facet: 'Features',
  integrated_with_facet: 'Integrated with',
  oses_facet: 'Devices supported',
  pricingcategories_facet: 'Pricing model',
  rating_facet: 'Overall rating',
  rating_stars_ge: 'User rating',
  time_used_facet: 'Time used',
  typecustomers_facet: 'Organization types',
};

export const buildDialogDictionary = (filters = []) => {
  const dialogDictorinary = filters.reduce((dictionary, filter) => {
    const group = filter.label[0].toUpperCase();
    const newDictionary = dictionary;
    if (!newDictionary[group]) {
      newDictionary[group] = [];
    }

    newDictionary[group].push(filter);

    return newDictionary;
  }, {});

  const sortedDialogDictorinary = Object.keys(dialogDictorinary)
    .sort()
    .reduce((acc, key) => {
      acc[key] = dialogDictorinary[key];
      return acc;
    }, {});

  return sortedDialogDictorinary;
};
